import { z } from 'zod';

export const formSchema = z.object({
  priority: z.string({ required_error: 'Selecione a prioridade' }),
});

export type FormSchema = z.infer<typeof formSchema>;